import {Link} from 'react-router-dom';
import Badge from './assets/badge';
import TubeGuy from './assets/tubeGuy.jsx';


function Title(props) {
    return (
        <div style={{
            width: '100%',
            height: '200px',
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'center',
            alignContent: 'center',
            alignItems: 'center',
            overflow: 'hidden',
            
          }}>
              <Link to='/'>
              <Badge color = {'black'}></Badge>
              {/* <div style={{
                marginLeft: '340px',
                alignSelf: 'center',
                position: 'absolute',
                marginBottom: '530px'
              }}>
              <TubeGuy/>
              </div> */}
              </Link>
              </div>
    )
}

export default Title;